import { SEARCH_BOOK, STATUS_CHANGE } from "./actionTypes";

export const changeFilterStatus = (payload) => {
    return {
        type: STATUS_CHANGE,
        payload: payload
    }
}

export const searchBook = (keyword) => {
    return {
        type: SEARCH_BOOK,
        payload: keyword
    }
}